<template>
  <compliance-booking :reschedule="false" />
</template>

<script>
import ComplianceBooking from './complianceBooking.vue';

export default {
  components: {
    ComplianceBooking,
  },
};
</script>

<style></style>
